/** Deterministic warm gradient from a string id — used as a photo fallback. */
const GRADIENTS = [
  'linear-gradient(135deg,#d8c3a5,#b89f7e)',
  'linear-gradient(135deg,#aeb4c4,#7d869c)',
  'linear-gradient(135deg,#d9b89e,#bd9276)',
  'linear-gradient(135deg,#9fb0a8,#74867e)',
  'linear-gradient(135deg,#c9b2c4,#9c7f97)',
  'linear-gradient(135deg,#c3cdd6,#94a3b0)',
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function gradientFor(id: string): string {
  return GRADIENTS[hash(id) % GRADIENTS.length];
}

/** Initials (max 2) from a display name. */
export function initialsOf(name: string): string {
  return (name || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
